module.exports = __webpack_public_path__ + "static/media/CTLI_14-178w.81ebd925.webp";